import axios from 'axios'
import {API_URL} from '../config'

const axiosServices = axios.create();

axiosServices.defaults.baseURL = API_URL;
axios.defaults.baseURL = API_URL;

axiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || error)
);

axios.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || error)
);

export default axiosServices;
